export const ThumbnailDetails = {
    POST_ThumbnailDetails: "POST_ThumbnailDetails"
   
}